export const LEFT = 1;
export const TOP = 2;
export const RIGHT = 3;
export const BOTTOM = 4;